import axios from 'axios';

// 各宿舍楼考勤统计（school:dormitory:attendanceStatistics）
export function attendanceStatistics(params) {
  return axios({
    url: '/school/dormitory/attendanceStatistics',
    method: 'GET',
    params: params,
  });
}

// 学生信息查询（（school:dormitory:studentSearch）
export function studentSearch(params) {
  return axios({
    url: '/school/dormitory/studentSearch',
    method: 'GET',
    params: params,
  });
}

// 考勤数据导出（school:dormitory:studentSignExport）
export function studentSignExport(params) {
  return axios({
    url: '/school/dormitory/studentSignExport',
    method: 'GET',
    params: params,
    responseType: 'blob',
  });
}

// 宿舍下拉选 （school:dormitory:towerSelect）
export function towerSelect(params) {
  return axios({
    url: '/school/dormitory/towerSelect',
    method: 'GET',
    params: params,
  });
}
